import { render } from "./BarcodeScanner.vue?vue&type=template&id=c0e985ee&scoped=true"
import script from "./BarcodeScanner.vue?vue&type=script&lang=js"
export * from "./BarcodeScanner.vue?vue&type=script&lang=js"

import "./BarcodeScanner.vue?vue&type=style&index=0&id=c0e985ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0e985ee"]])

export default __exports__